/**
 * Go To Top Component
 */
export class GoToTop {
    constructor() {
        // 기존 initgoToTop 로직 유지 (quick-menu에서 처리)
        // 필요시 별도 구현
    }
}

